module.exports = __webpack_public_path__ + "img/418.42d4a7c4.jpg";